module.exports = __webpack_public_path__ + "static/media/ic-content-creation.50191b66.svg";